import { render, staticRenderFns } from "./DienstplanPopover.vue?vue&type=template&id=36ed0faf&"
import script from "./DienstplanPopover.vue?vue&type=script&lang=ts&"
export * from "./DienstplanPopover.vue?vue&type=script&lang=ts&"
import style0 from "./DienstplanPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports